import React, { useState } from 'react';
import { Alert } from '@one-thd/sui-atomic-components';
import { FeatureSwitches } from '../../../constants/feature-switches';
export var CPSAnnouncementBanner = function () {
    var _a = useState(true), showBanner = _a[0], setShowBanner = _a[1];
    var handleClose = function () {
        setShowBanner(false);
    };
    if (!showBanner || !FeatureSwitches.enableCPSAnnouncementBanner)
        return null;
    return (React.createElement(Alert, { status: "info", size: "large", onClose: handleClose, headline: "Check out the new Purchase History features!" }, "Effortlessly find your orders or returns by searching by either item description, order number, or PO/Job name."));
};
